import { getSourceUrl } from "../lib/utils";
import { Beacon } from "./beacon";
import { Primitive } from "./metadata";

export interface CustomEventBeaconOptions {
  type: string;
  data: {
    sourceUrl: string;
    name: string;
    properties: {
      [key: string]: Primitive;
    };
  };
  identity?: {
    address?: string;
    customerUserId?: string;
  };
}

export function createCustomEventsPlugin(beacon: Beacon) {
  function track(
    name: string,
    properties?: Record<string, any>,
    identityProps?: {
      address?: string;
      customerUserId?: string;
    }
  ) {
    const sourceUrl = getSourceUrl();

    return beacon.sendBeacon<CustomEventBeaconOptions>({
      type: "CUSTOM",
      data: { name, properties, sourceUrl },
      identity: identityProps,
    });
  }

  return {
    track,
  };
}
